module.exports = __webpack_public_path__ + "img/united-kingdom.7ff5daca.png";